import logo from './logo.svg';
import './App.css';
import React, { useState } from 'react';
function App() {
const [activeItem, setActiveItem] = useState(null);

   const pageConfig = [
  { key: 'home', label: '地图编辑', component: HomePage },
  { key: 'GPS', label: '地图坐标点', component: GpsPage },
  { key: 'setCenter', label: '设置中心点', component: CenterPage }
  
];
const [activeKey, setActiveKey] = useState('home');
const ActiveComponent = pageConfig.find(item => item.key === activeKey)?.component;

  return (

<div className="app-container">
      <div className="sidebar">
        <h2>导航菜单</h2>
        <ul>
          {pageConfig.map(item => (
          <li
            key={item.key}
            className={activeKey === item.key ? 'active' : ''}
            onClick={() => setActiveKey(item.key)}
          >
            {item.label}
          </li>
        ))}
        </ul>
      </div>
      
      <div className="main-content">
        {ActiveComponent && <ActiveComponent />}
      </div>
    </div>
  );
}


function HomePage() {
  // return <h1>欢迎来到首页</h1>;

  return (

        <div>
        <iframe 
          src="/TmapEdit.html"  // 引入 public 文件夹中的 HTML 文件
          width="100%" 
          height="1024" 
          title=""
        />
      </div>
  );
}

function GpsPage() {
  return(

        <div>

        <iframe 
          src="/TmapGPS.html"  // 引入 public 文件夹中的 HTML 文件
          width="100%" 
          height="1024" 
          title=""
        />
      </div>
  );
}

function CenterPage() {
  return (

        <div>

        <iframe 
          src="/TmapSetCenter.html"  // 引入 public 文件夹中的 HTML 文件
          width="100%" 
          height="1024" 
          title=""
        />
      </div>
  );;
}

export default App;
